import React, { useContext } from 'react';
import {ErrorBoundary} from "react-error-boundary";
import FallbackComponent from "root/FallbackComponent";
import './ReportsPageBody.scss' ;
import PageBodyWrapper from "root/PageBodyWrapper";
import ReportPanel from "root/Reporting/ReportPanel";
import { Globals } from "root/globals";
import GlobalContext from "root/Contexts/GlobalContext";

const ReportsPageBody = (props) =>
{

    const sessionContext = useContext( GlobalContext ) ;

    const survey_type = sessionContext.getCurrentSurveyType() ;


    const onDownloadURL = ( url ) =>
    {
        window.open(Globals.APIFolder + url, '_blank');
    }

    const generalLinks = [
        { keyName:'actionsLink1', text: 'Download LAST years RAG summary', onClick: () => onDownloadURL ( '/csv/ragtotals?academic_year=last' ) , openAsNewTab: true, icon: 'bi bi-filetype-csv', style:{color: 'white'} },
        { keyName:'actionsLink2', text: 'Download this years RAG summary', onClick: () => onDownloadURL ( '/csv/ragtotals?academic_year=current' ) , openAsNewTab: true, icon: 'bi bi-filetype-csv', style:{color: 'white'} },
    ] ;

    const action6 = survey_type !== 'S360' ? [] : [{ keyName:'actionsLink6', text: 'Download the Combined Completion report', onClick: () => onDownloadURL ( '/csv/surveys/current/school-status' ) , openAsNewTab: true, icon: 'bi bi-filetype-csv', style:{color: 'white'} }]


    const userLinks = [
        { keyName:'actionsLink1', text: 'Download list of unactivated users', onClick: () => onDownloadURL ( '/csv/unactivatedusers' ) , openAsNewTab: true, icon: 'bi bi-filetype-csv', style:{color: 'white'} },
        { keyName:'actionsLink2', text: 'Download list of all users', onClick: () => onDownloadURL ( '/csv/allusers' ) , openAsNewTab: true, icon: 'bi bi-filetype-csv', style:{color: 'white'} },
        { keyName:'actionsLink3', text: 'Download a list of unfinished surveys', onClick: () => onDownloadURL ( '/csv/surveys/current/unfinished' ) , openAsNewTab: true, icon: 'bi bi-filetype-csv', style:{color: 'white'} },
        { keyName:'actionsLink4', text: 'Download a list of finished, unsubmitted surveys', onClick: () => onDownloadURL ( '/csv/surveys/current/finished-unsubmitted' ) , openAsNewTab: true, icon: 'bi bi-filetype-csv', style:{color: 'white'} },
        { keyName:'actionsLink5', text: 'Download a list of never-started surveys', onClick: () => onDownloadURL ( '/csv/surveys/current/not-started' ) , openAsNewTab: true, icon: 'bi bi-filetype-csv', style:{color: 'white'} },
        ...action6
    ] ;

    return (
        <ErrorBoundary  FallbackComponent={FallbackComponent}>
            <PageBodyWrapper title='Reports'>
              <div className='grid-page-layout'>
                  <ReportPanel image={'app/style/image/rag_report_icon.svg'} title='Rag Summary Report' color='var(--s360-safe-icon-red)' links={generalLinks}/>
                  <ReportPanel image={'app/style/image/users.svg'} title='User Reports' color='var(--s360-icon-blue)' links={userLinks}/>
              </div>
            </PageBodyWrapper>
            { /* <SlateEditor /> */}
        </ErrorBoundary>
    )
}

export default ReportsPageBody;
